import styled from '@emotion/styled/macro';

export const Container = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  z-index: 100;
  justify-content: center;
  align-items: center;
  display: flex;
`;
